const fares = {
  toast: {
    error: {
      badResponse: '[Fare] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Fare] criada com sucesso',
      },
      edit: {},
      delete: {
        default: '[Fare] excluída com sucesso',
      },
    },
  },
  createFareBtn: 'Criar',
  showBreakdownBtn: 'Mostrar detalhamento',
  total: 'Total: ',

  deleteModal: {
    header: 'Excluir Tarifas',
    body: 'Você está prestes a excluir as tarifas {{num}}.',
  },

  table: {
    headers: {
      biDir: 'Bidirecional',
    },
    biDirOptions: {
      way2: '2 Vias',
      way1: 'Só ida',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
  },

  fareTypeOptions: {
    Base: 'Base',
    Addition: 'Adição',
    Percent: 'Porcentagem',
    Total: 'Total',
  },

  additions: {
    value: 'Valor',
    valueType: 'Tipo do Valor',
    name: 'Nome',
    hour1: 'Horário de início',
    hour2: 'Horário final',
    date1: 'Data de início',
    date2: 'Data de término',
    cancel: 'Cancelar',
    addAddition: 'Adicionar Adição',
    priority: 'Prioridade',
    weekDays: 'Dias da Semana',
    newAddition: 'Nova adição',
    price: 'Preço',
    total: 'Total',
    percent: 'Porcentagem',
    columnExist: 'O título já existe',
  },

  create: {
    confirmButtonText: 'Confirmar',
    code: 'Código',
    from: 'De',
    to: 'Para',
    service: 'Serviços',
    select: 'Selecione',
    validations: {
      code: 'O código é obrigatório',
    },

    successToast: {
      message: 'sucesso! tarifa criada.',
    },
    errorToast: {
      message: 'Ocorreu um erro! Não foi possível criar tarifa',
    },
  },

  update: {
    code: 'Código',
    from: 'De',
    to: 'Para',
    service: 'Serviços',
    price: 'Preço',
    confirmButtonText: 'Atualizar',
    successMsg: 'Taxa atualizada com sucesso',

    successToast: {
      message: 'sucesso! Taxa atualizada com sucesso.',
    },
    errorToast: {
      message: 'Ocorreu um erro! Não foi possível atualizar a tarifa',
    },
  },

  validations: {
    code: {
      require: 'O código é obrigatório',
    },
    from: {
      require: 'De é obrigatório',
    },
    to: {
      require: 'Para é obrigatório',
    },
    service: {
      require: 'A assistência é necessária',
    },
    unit: {
      require: 'Requer-se a unidade',
    },
    rateType: {
      require: 'O tipo de taxa é obrigatório',
    },
  },
  forms: {
    header: {
      createFare: {
        title: 'Criar',
      },

      updateFare: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalhes da tarifa',
        fields: {
          units: {
            name: 'Locais',
          },
          name: {
            name: 'Nome',
          },
          group: {
            name: 'Agrupar',
          },
          services: {
            name: 'Serviços',
          },
          biDirectional: {
            name: 'Direcional',
          },
          from: {
            name: 'Da zona',
          },
          to: {
            name: 'Para a zona',
          },
        },
      },
      mileage: {
        header: 'Quilometragem',
        fields: {
          distanceFrom: {
            name: 'Distância de',
          },
          distanceTo: {
            name: 'Distância até',
          },
        },
      },
      conditions: {
        header: 'Condições',
        fields: {
          startDate: {
            name: 'Data de início',
          },
          endDate: {
            name: 'Data de término',
          },
          startHour: {
            name: 'Horário de início',
          },
          endHour: {
            name: 'Horário final',
          },
          weekDays: {
            name: 'Dias úteis',
          },
          fromDate: {
            name: 'A partir da Data',
          },
          toDate: {
            name: 'Até à data',
          },
        },
      },
    },
  },
};

export default fares;
